import { createFileRoute } from "@tanstack/react-router";
import { z } from "zod";
import { AdminBookingsView } from "@/components/admin/AdminBookingsView";

const bookingsSearchSchema = z.object({
  book: z.coerce.number().optional(),
});

export const Route = createFileRoute("/_authenticated/admin/bookings")({
  validateSearch: bookingsSearchSchema,
  head: () => ({ meta: [{ title: "Bookings — Admin" }] }),
  component: AdminBookingsPage,
});

function AdminBookingsPage() {
  const { book } = Route.useSearch();
  return <AdminBookingsView book={book} />;
}
